import { useRef } from 'react'
import useFixedBottomPadding from '../../../hooks/common/useFixedBottomPadding'
import './index.scss'

export default function FixedBottom({ children, elementPaddingBottom = 'app' }) {
  const ref = useRef(null)

  useFixedBottomPadding(ref, elementPaddingBottom)

  return (
    <div ref={ref} className="FixedBottom">
      {children}
    </div>
  )
}
